export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJR0JLLUVVQy1IYRShogCEPwAAhD4GAIRWAAG8GAAAhFcEDYRGPgC8GoMiAIRCBgGERAIAhD0BALwbCwGEQAEAvBwBAIRDGwC8HQEAvB4BAIRYGwCEVAEAhFUAALwf", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBK-EUC-V.bcmap
// module id = 640
// module chunks = 502